import React, { useContext, useEffect, useState } from 'react'
import Comment from '../components/Comment'
import getWhiskeyDetails from '../firebase/getWhiskeyDetails'
import { useParams } from 'react-router-dom'
import { UserContext } from '../App'
import createComment from '../firebase/createComment'
import readComments from '../firebase/readComments'
import RatingNumber from '../components/RatingNumber'
import getRatings from '../firebase/getRatings'
import addRating from '../firebase/addRating'
import deleteComment from '../firebase/deleteComment'

const WhiskeyDetails = () => {
    const { id } = useParams()

    const [whiskey, setWhiskey] = useState({})
    const [comment, setComment] = useState("")
    const [comments, setComments] = useState([])
    const user = useContext(UserContext)
    const [number1, setNumber1] = useState([1, 2, 3, 4, 5])
    const [number2, setNumber2] = useState([1, 2, 3, 4, 5])
    const [number3, setNumber3] = useState([1, 2, 3, 4, 5])
    const [selectedNumber1, setSelectedNumber1] = useState(null)
    const [selectedNumber2, setSelectedNumber2] = useState(null)
    const [selectedNumber3, setSelectedNumber3] = useState(null)
    const [rating, setRating] = useState(1);
    const [ratingDoft, setRatingDoft] = useState(0);
    const [ratingTaste, setRatingTaste] = useState(0);
    const [ratingEnding, setRatingEnding] = useState(0);
    const [dateEnding, setDateEnding] = useState(":e")
    const [_date, set_date] = useState("")
    const [eyesOnRobert, setEyesOnRobert] = useState(false)

    const year = new Date().getFullYear()
    const month = new Date().getMonth() + 1
    const day = new Date().getDate().toString().padStart(2, "0")
    const [currentDate, setCurrentDate] = useState(year + "-" + month + "-" + day)
    const [compareDate, setCompareDate] = useState("")


    useEffect(() => {

        getWhiskey(id)
        getComments(id)
        getWhiskeyRatings()
        setTitleOfHTML(_date, dateEnding)
        window.scrollTo(0, 0)



    }, [id, _date, dateEnding])

    const validateTextInput = () => {
        if (comment.trim() !== "" && comment.trim().length > 5 && user.id !== "CiJxnOn3ukL048jq5AZU") {
            return true
        }
        else if (comment.trim() !== "" && comment.trim().length > 5 && user.id === "CiJxnOn3ukL048jq5AZU") {
            setEyesOnRobert(true)
            return true
        }
        else {

            return false
        }
    }

    const handleSubmit = async (e) => {
        // e.preventDefault()
        setEyesOnRobert(false)
        let validate = validateTextInput()
        if (validate) {
            await createComment(comment, user.id, id)
            const _comments = await readComments(id)
            setComments([..._comments])
            setComment("")
        }
    }

    const getWhiskey = async (_id) => {
        const _whiskey = await getWhiskeyDetails(_id)
        setWhiskey({ ..._whiskey })
        set_date(new Date(_whiskey.date.seconds * 1000).getDate())
        setEndingOfDate()
        setCompareDate(new Date(_whiskey.date.seconds * 1000).toLocaleDateString('sv-se'))
    }

    const getComments = async (_id) => {
        const _comments = await readComments(_id)
        setComments([..._comments])
    }

    const setAverageRatings = (doft, taste, ending) => {
        let _score = 0

        doft.map(i => {
            _score += i.score
            setRatingDoft(Math.round(_score / doft.length * 10) / 10)
        })
        _score = 0
        taste.map(i => {
            _score += i.score
            setRatingTaste(Math.round(_score / taste.length * 10) / 10)
        })
        _score = 0
        ending.map(i => {
            _score += i.score
            setRatingEnding(Math.round(_score / ending.length * 10) / 10)
        })
    }

    const getWhiskeyRatings = async () => {
        const { ratings1, ratings2, ratings3, score } = await getRatings(id)
        setAverageRatings(ratings1, ratings2, ratings3)
        setRating(Math.round(score * 10) / 10)
        // setRatingDoft(Math.round(score * 10) / 10)
        // setRatingTaste(Math.round(score * 10) / 10)
        // setRatingEnding(Math.round(score * 10) / 10)
        if (!ratings1.find(r => { return r.userId === user.id })) {
            return
        }
        else {
            setSelectedNumber1(ratings1.find(r => { return r.userId === user.id }).score)

        }
        if (!ratings2.find(r => { return r.userId === user.id })) {
            return
        }
        else {
            setSelectedNumber2(ratings2.find(r => { return r.userId === user.id }).score)

        }
        if (!ratings3.find(r => { return r.userId === user.id })) {
            return
        }
        else {
            setSelectedNumber3(ratings3.find(r => { return r.userId === user.id }).score)

        }
    }

    const handleOnClick = async (e, type) => {
        const _selectedNumber = Number(e.target.textContent)

        switch (type) {
            case 1:
                if (selectedNumber1 === _selectedNumber) {
                    setSelectedNumber1(null)
                }
                else {

                    setSelectedNumber1(_selectedNumber)
                }
                break;
            case 2:
                if (selectedNumber2 === _selectedNumber) {
                    setSelectedNumber2(null)
                }
                else {

                    setSelectedNumber2(_selectedNumber)
                }
                break;

            default:
                if (selectedNumber3 === _selectedNumber) {
                    setSelectedNumber3(null)
                }
                else {

                    setSelectedNumber3(_selectedNumber)
                }
                break;
        }
        await addRating(_selectedNumber, user.id, id, type)
        const { ratings1, ratings2, ratings3, score } = await getRatings(id)
        setRating(Math.round(score * 10) / 10)
        if (!ratings1.find(r => { return r.userId === user.id })) {
            return
        }
        else {
            setSelectedNumber1(ratings1.find(r => { return r.userId === user.id }).score)

        }
        if (!ratings2.find(r => { return r.userId === user.id })) {
            return
        }
        else {
            setSelectedNumber2(ratings2.find(r => { return r.userId === user.id }).score)

        }
        if (!ratings3.find(r => { return r.userId === user.id })) {
            return
        }
        else {
            setSelectedNumber3(ratings3.find(r => { return r.userId === user.id }).score)

        }
    }

    const removeComment = async (c) => {
        await deleteComment(c)
        setComments(state => state.filter(i => i.id !== c))
    }

    const setEndingOfDate = () => {
        // set_date(new Date(whiskey.date.seconds * 1000).getDate())
        switch (Number(_date)) {
            case 1:
                setDateEnding(":a")
                break;
            case 2:
                setDateEnding(":a")
                break;
            case 21:
                setDateEnding(":a")
                break;
            case 22:
                setDateEnding(":a")
                break;
            default:
                setDateEnding(":e")
                break;
        }

    }



    const setTitleOfHTML = (_date, dateEnding) => {
        document.title = _date + dateEnding + " December"
    }
    if (!user.id || currentDate < compareDate) {
        return (<div className='flex flex-3 justify-between md:basis-1/3 ' >
            <div className='px-4 animate__animated animate__slideInLeft'>
                <h3 className='text-xl text-gray-600 font-bold justify-self-start'>Whiskeykalendern</h3>
                <h3 className='text-3xl text-gray-600 font-bold'>Du måste logga in för att se nånting!</h3>
                <h3 className='text-xl text-gray-400 font-bold'>Eller är du kanske för tidig?</h3>
            </div></div>)
    }
    else {
        return (
            <>{whiskey && <>

                <h3 className='px-4 text-3xl mb-4 font-bold text-gray-400 container'>{_date}{dateEnding} December</h3>
                <div className='flex flex-col md:flex-row container h-full pb-52 justify-between dark:text-white h-full'>
                    <div className='flex flex-3 justify-between md:basis-1/3 ' >
                        <div className='px-4 animate__animated animate__slideInLeft'>
                            <h3 className='text-xl text-gray-600 font-bold justify-self-start'>{whiskey.origin}</h3>
                            <h3 className='text-3xl font-bold'>{whiskey.name}</h3>
                            <h3 className='text-xl text-gray-400 font-bold'>{whiskey.subName}</h3>
                            <img className='w-44 md:w-60 object-contain mt-24 m-auto animate__animated animate__slideInLeft animate__fast' src={whiskey.image} alt='' />
                        </div>
                    </div>
                    <div className='basis-2/3 flex flex-col md:flex-row justify-between flex-2'>
                        <div className='h-full basis-1/3 flex justify-center items-center mt-24'>
                            <div className='divider w-full md:h-full mx-4 mb-4 '></div>
                        </div>
                        <div className='flex justify-between flex-col h-full basis-1/1 px-4 w-full animate__animated animate__slideInRight'>
                            <div>
                                <h6 className='text-2xl font-bold mb-1'>Beskrivning</h6>
                                <p className='basis-9/10 text-sm'>{whiskey.details}</p>
                                {whiskey.minorDetails && <div className='py-4'>
                                    <h6 className='text-xl font-bold mt-2'>Doft</h6>
                                    <p className='basis-9/10 text-sm'>{whiskey.minorDetails.doft}</p>
                                    <h6 className='text-xl font-bold mt-2'>Smak</h6>
                                    <p className='basis-9/10 text-sm'>{whiskey.minorDetails.smak}</p>
                                    <h6 className='text-xl font-bold mt-2'>Avslutning</h6>
                                    <p className='basis-9/10 text-sm'>{whiskey.minorDetails.avslutning}</p></div>}
                                <h6 className='text-lg font-bold mt-2'>Alkoholhalt</h6>
                                <p className='basis-9/10 text-sm'>{whiskey.percentage}</p>
                                {user.loggedIn && <div className=' mt-8 animate__animated animate__slideInRight animate__fast'>

                                    <span className="text-xl text-white w-full font-bold">Betygsätt</span>
                                    <div className="flex justify-between w-full mt-1 flex-col items-start">
                                        <span className="text-md text-white w-20 mt-4 font-bold border-b border-gray-800 mb-2">Doft</span>
                                        <div className="flex justify-evenly w-full">
                                            {number1.map((n) =>
                                                <RatingNumber handleOnClick={handleOnClick} type={1} selectedNumber={selectedNumber1} number={n} key={n} />
                                            )}
                                        </div>
                                        <span className="text-md text-white w-20 mt-4 font-bold border-b border-gray-800 mb-2">Smak</span>
                                        <div className="flex justify-evenly w-full">
                                            {number2.map((n) =>
                                                <RatingNumber handleOnClick={handleOnClick} type={2} selectedNumber={selectedNumber2} number={n} key={n} />
                                            )}
                                        </div>
                                        <span className="text-md text-white w-20 mt-4 font-bold border-b border-gray-800 mb-2">Avslutning</span>
                                        <div className="flex justify-evenly w-full">
                                            {number3.map((n) =>
                                                <RatingNumber handleOnClick={handleOnClick} type={3} selectedNumber={selectedNumber3} number={n} key={n} />
                                            )}
                                        </div>

                                    </div>
                                    <div className='flex gap-3 mt-4'>


                                        <div className='mt-2 flex  dark:text-white flex-col w-full'>
                                            <h2 className="mt-4 font-bold text-lg dark:text-white w-full">Doft</h2>
                                            <span className="text-sm text-gray-400">{!ratingDoft ? "-" : ratingDoft} / 5</span>
                                        </div>

                                        <div className='mt-2 flex  dark:text-white flex-col w-full'>
                                            <h2 className="mt-4 font-bold text-lg dark:text-white w-full">Smak</h2>
                                            <span className="text-sm text-gray-400">{!ratingTaste ? "-" : ratingTaste} / 5</span>
                                        </div>

                                        <div className='mt-2 flex  dark:text-white flex-col w-full'>
                                            <h2 className="mt-4 font-bold text-lg dark:text-white w-full">Avslutning</h2>
                                            <span className="text-sm text-gray-400">{!ratingEnding ? "-" : ratingEnding} / 5</span>
                                        </div>
                                    </div>
                                    <h2 className="mt-4 font-bold text-xl dark:text-white w-full">Betyg</h2>

                                    <div className='mt-2 flex  dark:text-white flex-col w-full'>
                                        <span className="text-sm text-gray-400">{!rating ? "-" : rating} / 5</span>
                                    </div>
                                </div>}
                                <h6 className='font-bold mt-8'>Intresserad att köpa?</h6>
                                <span className='mt-8 '><a href={whiskey.linkBolaget} className='basis-9/10 mt-8 hover:text-gray-300 text-sm'>Länk till systembolaget</a></span>

                            </div>
                            {user.loggedIn && <div className="mt-4 w-auto basis-1/10">
                                <h4 className="dark:text-white">Kommentarer</h4>
                                <div className="col-span-full">
                                    <div className="mt-2">
                                        <textarea
                                            id="about"
                                            name="about"
                                            rows={3}
                                            className="block w-full rounded-md border-0 py-1.5 px-1.5 text-gray-400 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            placeholder='Skriv en kommentar..'
                                            onChange={(e) => setComment(e.target.value)}
                                            value={comment}
                                        />
                                        {eyesOnRobert && <span className='font-bold text-2xl text-red-500'>I've got my eyes on you!</span>}
                                    </div>
                                    <button
                                        type='click'
                                        className="rounded-md mt-2 mb-4 px-3 py-2 text-sm font-semibold text-white shadow-sm bg-gray-700 hover:bg-gray-600" onClick={() => handleSubmit()}
                                    >
                                        Skicka
                                    </button>
                                    <div className="flex gap-3 flex-col mt-2">
                                        {comments.sort((a, b) => b.created - a.created).map(c => <Comment key={c.id} comment={c} user={user} removeComment={removeComment} />)}
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>

                </div></>}

            </>
        )
    }
}

export default WhiskeyDetails